import { makeAutoObservable } from "mobx"
import { LoginService } from "../services/api/loginService"
import { User, UserLoginRequest, UserChangePasswordRequest } from "../models/user";
import { Cookies } from "react-cookie";
import moment from "moment";

export class LoginStore {
    loginService = new LoginService();
    user: User = {} as User;
    accessToken: string = '';
    cookie: Cookies = new Cookies();
    accessMessage = '';

    constructor() {
        makeAutoObservable(this);
        this.load()
    }

    load = async() => {
    }

    userLogin = async (user: UserLoginRequest) => {
        try {
            const response = await this.loginService.userLogin(user);
            if (response.status === 401 || response.status === 'Unauthorized') {
                if (response.code === "err-login-password-expired") {
                    window.location.replace("/changePassword");
                } else {
                    this.accessMessage = 'Username o password errati';
                }
            } else {
                this.accessMessage = '';
                this.accessToken = response.jwtToken;
                this.cookie.set('_bId', response.bankId, {expires: moment().add(2, 'hour').toDate()});
            }
        } catch (e) {
            console.log(e);
        }
    }

    userChangePassword = async (user: UserChangePasswordRequest) => {
        try {
            const response = await this.loginService.userChangePassword(user);
            if (response.status === 401 || response.status === 'Unauthorized') {
                this.accessMessage = response.message;
            } else {
                this.accessMessage = '';
            }
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    resetAccessToken = () => {
        this.accessToken = '';
    }

    logout = () => {
        this.cookie.remove('_ath',{path:'/'});
        this.cookie.remove('_bId',{path:'/'});
        window.location.replace('/login');
    }
}